/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-01-16 17:06:28
 * @LastEditors: dongjing
 * @LastEditTime: 2020-01-16 17:12:56
 */
const loader = (name: string) => async () => {
  const entrance = await import(/* webpackChunkName: "f.mall" */ './');
  return entrance[name];
};

import { IRoute } from 'src/types';

export const childRoutes: IRoute[] = [
  {
    load: loader('HomePage'),
    path: ''
  }
];
export default {
  path: 'mall',
  name: 'mall',
  childRoutes
};
